import { Grid } from '@chakra-ui/react';
import { ContractSearchResponseDTO } from 'models';
import formatter from 'utils/formatter';
import { DetailItem } from './DetailItem';

interface ViewFormProps {
   contract: ContractSearchResponseDTO;
}

export const ViewVehicleFormReadOnly = ({ contract }: ViewFormProps) => {
    const { veiculo } = contract;

  return (
    <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={4}>
      <DetailItem label="Chassi" value={veiculo?.chassi} />
      <DetailItem label="Placa" value={formatter.placa(veiculo?.placa)} />
      <DetailItem label="Renavam" value={veiculo?.renavam} />
      <DetailItem label="Ano Fabricação" value={veiculo?.anoFabricacao} />
      <DetailItem label="Ano Modelo" value={veiculo?.anoModelo} />
      <DetailItem label="Cor" value={veiculo?.cor} />
      <DetailItem label="Marca" value={veiculo?.marca} />
      <DetailItem label="UF" value={veiculo?.uf} />
      <DetailItem label="Espécie" value={veiculo?.especie} />
    </Grid>
  );
};